import alt from 'framework/alt';

class HelpActions {
  constructor() {
    this.generateActions(
      'getHelpStarted',
      'getHelpSucceeded',
      'getHelpFailed',
    );
  }
}

export default alt.createActions(HelpActions);
